import { Stack } from "@mui/material";
import { useContext } from "react";

import EntitiesStep from "../Common/EntitiesStep/EntitiesStep";
import InfoStep from "../Common/InfoStep/InfoStep";
import ThemeContext from "../context";
import FundsSelections from "./FundsSelection/FundsSelections";
import ImportingStep from "./ImportingStep/ImportingStep";
import RevisionStep from "./RevsionStep/RevisionStep";
import TransfersConnectStep from "./TransfersConnectStep";
import TransfersSuccessStep from "./TransfersSuccessStep";

// ----------------------------------------------------------------------

export const TransfersContent = () => {
	const { state } = useContext(ThemeContext);

	return (
		<Stack>
			{state.step === 0 && <InfoStep title={"transfers.title"} aboutData={"transfers.des"} />}
			{state.step === 1 && <EntitiesStep />}
			{state.step === 2 && <TransfersConnectStep />}
			{state.step === 3 && <ImportingStep />}
			{state.step === 4 && <FundsSelections />}
			{state.step === 5 && <RevisionStep />}
			{state.step === 6 && <TransfersSuccessStep />}
		</Stack>
	);
};

export default TransfersContent;
